import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SectorsHero } from '../components/sectors/SectorsHero';
import { SectorsEcosystems } from '../components/sectors/SectorsEcosystems';
import { SectorsFoundation } from '../components/sectors/SectorsFoundation';
import { SectorsCTA } from '../components/sectors/SectorsCTA';
export function Sectors() {
  return <div className="w-full min-h-screen bg-white" data-id="element-8669" data-mp="dxvjk1wlh2fk">
      <Header data-id="element-8670" data-mp="e19lxa59dbn0" />
      <main className="pt-[120px]" data-id="element-8671" data-mp="ixqag5gdds0m">
        <SectorsHero data-id="element-8672" data-mp="iwyn1hwxf0lf" />
        <SectorsEcosystems data-id="element-8673" data-mp="iw5gagxywb3a" />
        <SectorsFoundation data-id="element-8674" data-mp="nx37tk4vahhg" />
        <SectorsCTA data-id="element-8675" data-mp="nwtg9s46c29n" />
      </main>
      <Footer data-id="element-8676" data-mp="nxmeu5szblgp" />
    </div>;
}